module.exports = __webpack_public_path__ + "static/media/starSelected.325c0368.png";